

import { Form, TFile, TGlobal, TLangObject } from '@brg/api';
import { Designer, Point, Team } from '@brg/api';

/**
 * @deprecated
 * @param def
 */
export function createDefaultLangObject(def = 'Undefined', currentLang = false): TLangObject<TGlobal> {
    return [
        { lang: 'Ru', name: def, ...(currentLang ? { currentLang: 'ru' } : {}) },
        { lang: 'En', name: def, ...(currentLang ? { currentLang: 'ru' } : {}) },
    ];
}

/**
 *  @deprecated
 */
export function createDefaultFile(): TFile & any {
    return {
        fileId: '',
        containerId: '',
        isDeleted: false,
        isNew: false,
        type: 'projectimages',
        url: 'projectimages/0/f31b2fda5b0f4d33b06202809d106e71/ea33cdaa96624381a1b159a55e4c1fc6_orig.jpg',
        size: null as any,
        localization: 'global',
    };
}

/**
 *  @deprecated
 */
export function createDefaultPoint(): Point {
    return {
        pointId: '',
        countryId: '',
        name: createDefaultLangObject('Unplaced') as any,
        city: createDefaultLangObject('Undefined') as any,
        country: createDefaultLangObject('Undefined') as any,
        longitude: 0,
        latitude: 0,
        internalId: null as never,
    };
}

export function createDefaultTeam(): Team {
    return {
        internalId: null as never,
        teamId: '',
        name: createDefaultLangObject('Undefined context') as any,
        pointId: '',
        point: createDefaultPoint(),
        created: new Date().toString(),
        edited: new Date().toString(),
        about: createDefaultLangObject('about') as any,
        membersIDs: [],
        pendingMemberIds: [],
        pendingProjectIds: [],
        members: [],
        owners: [],
        ownersIDs: [],
        projectIds: [],
        tagIds: [],
        tags: [],
        avatar: [],
        route: '',
        formIds: [],
        coverLink: {
            path: '',
            newTab: false
        },
        isSwitchButtonVisible: false

    };
}

export function createDefaultGroup() {
    return {
        about: createDefaultLangObject('') as any,
        name: createDefaultLangObject('') as any,
        ownersIDs: [],
        membersIDs: [],
        managedTagIds: [],
        contexts: [],
        owners: [],
        members: [],
        managedTags:[],
    }
}

export function createDefaultForm(): Form {
    return {
        formId: '',
        techName: '',
        header: createDefaultLangObject('') as any,
        description: createDefaultLangObject('') as any,
        teamId: '',
        integration: {
            //@ts-ignore
            funnelId: undefined,
            crmTags: [
                ''
            ],
            additionalFields: [
                {
                    name: createDefaultLangObject('') as any,
                    value: createDefaultLangObject('') as any,
                }
            ],
        },
        textOnComplete: createDefaultLangObject('') as any,
        textSubmitButton: createDefaultLangObject('') as any,
        pndFields: [
            {
                name: createDefaultLangObject('') as any,
                value: createDefaultLangObject('') as any,
            }
        ],
        formFields: [
            {
                type: 0,
                header: createDefaultLangObject('') as any,
                placeholder: createDefaultLangObject('') as any,
                isRequired: true,
            }
        ],
    };
}

export function createDefaultCriteria() {
    return {
        voteCriteriaId: '',
        name: createDefaultLangObject('') as any,
        minValue: 1,
        maxValue: 5,
        currentLang: 'ru',
    }
}

/**
 *  @deprecated
 */
export function createDefaultDesigner(): Designer {
    return {
        internalId: null as never,
        designerId: '',
        name: createDefaultLangObject('Undefined') as any,
        family: createDefaultLangObject('Unnamed') as any,
        about: createDefaultLangObject('Empty') as any,
        avatar: [createDefaultFile()],
        socialNetworks: {} as any,
    } as any;
}


import { Form, TFile, TGlobal, TLangObject } from '@brg/api';
import { Designer, Point, Team } from '@brg/api';

/**
 * @deprecated
 * @param def
 */
export function createDefaultLangObject(def = 'Undefined', currentLang = false): TLangObject<TGlobal> {
    return [
        { lang: 'Ru', name: def, ...(currentLang ? { currentLang: 'ru' } : {}) },
        { lang: 'En', name: def, ...(currentLang ? { currentLang: 'ru' } : {}) },
    ];
}

/**
 *  @deprecated
 */
export function createDefaultFile(): TFile & any {
    return {
        fileId: '',
        containerId: '',
        isDeleted: false,
        isNew: false,
        type: 'projectimages',
        url: 'projectimages/0/f31b2fda5b0f4d33b06202809d106e71/ea33cdaa96624381a1b159a55e4c1fc6_orig.jpg',
        size: null as any,
        localization: 'global',
    };
}

/**
 *  @deprecated
 */
export function createDefaultPoint(): Point {
    return {
        pointId: '',
        countryId: '',
        name: createDefaultLangObject('Unplaced') as any,
        city: createDefaultLangObject('Undefined') as any,
        country: createDefaultLangObject('Undefined') as any,
        longitude: 0,
        latitude: 0,
        internalId: null as never,
    };
}

export function createDefaultTeam(): Team {
    return {
        internalId: null as never,
        teamId: '',
        name: createDefaultLangObject('Undefined context') as any,
        pointId: '',
        point: createDefaultPoint(),
        created: new Date().toString(),
        edited: new Date().toString(),
        about: createDefaultLangObject('about') as any,
        membersIDs: [],
        pendingMemberIds: [],
        pendingProjectIds: [],
        members: [],
        owners: [],
        ownersIDs: [],
        projectIds: [],
        tagIds: [],
        tags: [],
        avatar: [],
        route: '',
        formIds: [],
        coverLink: {
            path: '',
            newTab: false
        },
        isSwitchButtonVisible: false

    };
}

export function createDefaultGroup() {
    return {
        about: createDefaultLangObject('') as any,
        name: createDefaultLangObject('') as any,
        ownersIDs: [],
        membersIDs: [],
        managedTagIds: [],
        contexts: [],
        owners: [],
        members: [],
        managedTags:[],
    }
}

export function createDefaultForm(): Form {
    return {
        formId: '',
        techName: '',
        header: createDefaultLangObject('') as any,
        description: createDefaultLangObject('') as any,
        teamId: '',
        integration: {
            //@ts-ignore
            funnelId: undefined,
            crmTags: [
                ''
            ],
            additionalFields: [
                {
                    name: createDefaultLangObject('') as any,
                    value: createDefaultLangObject('') as any,
                }
            ],
        },
        textOnComplete: createDefaultLangObject('') as any,
        textSubmitButton: createDefaultLangObject('') as any,
        pndFields: [
            {
                name: createDefaultLangObject('') as any,
                value: createDefaultLangObject('') as any,
            }
        ],
        formFields: [
            {
                type: 0,
                header: createDefaultLangObject('') as any,
                placeholder: createDefaultLangObject('') as any,
                isRequired: true,
            }
        ],
    };
}

export function createDefaultCriteria() {
    return {
        voteCriteriaId: '',
        name: createDefaultLangObject('') as any,
        minValue: 1,
        maxValue: 5,
        currentLang: 'ru',
    }
}

/**
 *  @deprecated
 */
export function createDefaultDesigner(): Designer {
    return {
        internalId: null as never,
        designerId: '',
        name: createDefaultLangObject('Undefined') as any,
        family: createDefaultLangObject('Unnamed') as any,
        about: createDefaultLangObject('Empty') as any,
        avatar: [createDefaultFile()],
        socialNetworks: {} as any,
    } as any;
}
